var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconEdit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "512px",
    height: "512px",
    viewBox: "0 0 512 512",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-edit") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon-edit",
    transform: "translate(0.000000, 0.000500)",
    fill: "#0094FF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M415,221.9835 C406.716,221.9835 400,228.6995 400,236.9835 L400,456.9835 C400,470.7685 388.785,481.9835 375,481.9835 L55,481.9835 C41.215,481.9835 30,470.7685 30,456.9835 L30,136.9835 C30,123.1985 41.215,111.9835 55,111.9835 L275,111.9835 C283.284,111.9835 290,105.2675 290,96.9835 C290,88.6995 283.284,81.9835 275,81.9835 L55,81.9835 C24.673,81.9835 0,106.6565 0,136.9835 L0,456.9835 C0,487.3105 24.673,511.9835 55,511.9835 L375,511.9835 C405.327,511.9835 430,487.3105 430,456.9835 L430,236.9835 C430,228.6995 423.284,221.9835 415,221.9835 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.749,38.5195 L473.464,10.2345 C459.819,-3.4115 437.615,-3.4115 423.967,10.2345 L197.694,236.5085 C195.6,238.6025 194.173,241.2695 193.591,244.1735 L179.448,314.8845 C178.465,319.8025 180.004,324.8865 183.551,328.4325 C186.392,331.2735 190.219,332.8265 194.157,332.8265 C195.136,332.8265 196.12,332.7305 197.098,332.5355 L267.809,318.3925 C270.713,317.8115 273.38,316.3835 275.474,314.2895 L501.749,88.0165 C501.749,88.0165 501.75,88.0165 501.75,88.0155 C515.395,74.3705 515.395,52.1665 501.749,38.5195 Z M257.473,289.8655 L213.279,298.7055 L222.119,254.5115 L406.289,70.3385 L441.645,105.6945 L257.473,289.8655 Z M480.536,66.8035 L462.858,84.4815 L427.502,49.1255 L445.179,31.4485 C447.129,29.4985 450.301,29.4975 452.251,31.4475 L480.535,59.7325 C482.486,61.6815 482.486,64.8545 480.536,66.8035 Z",
    id: "Shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEdit);
export default __webpack_public_path__ + "static/media/icon-edit.396b0969751ec8ca4a269d2e685342bc.svg";
export { ForwardRef as ReactComponent };